module.exports = __webpack_public_path__ + "static/media/compassionate2.3bbf74a5.png";